<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheadingBold">
          <div class="ml-4 mt-4">
            Access Request Originator
          </div>
          <v-spacer/>
          <div class="mr-4 mt-4">
            {{displayDocumentIDGTypeA("U1", this.localForm.useridg)}}
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.username"
            prepend-icon="account_circle"
            hint="name"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.useremail"
            prepend-icon="mail"
            hint="email"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-spacer/>
          <UserInfoCard :data="this.getDetail"/>
        </v-layout>
        <v-layout row :class="ui.textSubheadingBold">
          <div class="ml-4 mt-4">
            {{item.title}}
          </div>
          <v-spacer/>
          <div class="mr-4 mt-4">
            {{displayDocumentIDGTypeA(item.tag, this.localForm.objectidg)}}
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.objectname"
            :prepend-icon="localForm.objecticon"
            :hint="  this.localForm.objecthint"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.objectid"
            prepend-icon="fingerprint"
            :hint="this.localForm.objecthints"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.authLevel"
            prepend-icon="key"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import UserInfoCard from "@/user/user/components/UserInfoCard";
import describeAccess from "@/data/describe/mixins/describeAccess";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import { mapGetters } from "vuex";
export default {
  components: {
    UserInfoCard
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    numberFunctions,
    describeDocument,
    describeAccess,
    displayFunctions,
    docLogFunctions
  ],
  data() {
    return {
      valid: true,
      localForm: {
        username: "",
        useremail: "",
        objectname: "", // company or facility
        objectid: "", // company or facility
        objecticon: "",
        objecthint: "",
        objecthints: "",
        authLevel: ""
      }
    };
  },
  beforeMount() {
    // PREP DOCUMEN
    this.prepareForDocumentLog();
    // fix orginal data before change
    this.localForm.username = this.getDetail.char.utitle;
    this.localForm.useremail = this.getDetail.char.uemail;
    this.localForm.useridg = this.getDetail.char.uidg;
    // source doc.
    this.localForm.objectname = this.getDetail.char.title;
    this.localForm.objectid = this.getDetail.char.id;
    this.localForm.objectidg = this.getDetail.char.idg;
    // eslint-disable-next-line
    this.localForm.objecticon = this.defineDocumentFromTag(this.item.tag).icon;
    // eslint-disable-next-line
    this.localForm.objecthint = this.defineDocumentFromTag(this.item.tag).hint;
    // eslint-disable-next-line
    this.localForm.objecthints = this.defineDocumentFromTag(this.item.tag).hints;
    if (this.item.tag === "C1") {
      let auth = this.getDetail.select.cauth;
      if (auth === null) {
        this.localForm.authLevel = "Access Undefined";
      } else {
        this.localForm.authLevel = this.defineAccess(this.item.tag, auth).title;
      }
    } else {
      let auth = this.getDetail.select.fauth;
      if (auth === null) {
        this.localForm.authLevel = "Access Undefined";
      } else {
        this.localForm.authLevel = this.defineAccess(this.item.tag, auth).title;
      }
    }
  },
  computed: {
    ...mapGetters(["getDetail"]),
    type() {
      return "Comp";
    },
    item() {
      let obj = {
        title: "",
        tag: ""
      };
      let tagd = this.getDetail.basic.tagd;
      let tags = this.getDetail.basic.tags;
      if (tagd === "C1" && tags === "U1") {
        obj.title = "Company User Access";
        obj.tag = "C1";
      } else if (tagd === "Z5" && tags === "C1") {
        obj.title = "New Company Request";
        obj.tag = "C1";
      } else if (tagd === "U1" && tags === "C1") {
        obj.title = "User Company Access";
        obj.tag = "C1";
      } else if (tagd === "U1" && tags === "F1") {
        obj.title = "User Facility Access";
        obj.tag = "F1";
      } else if (tagd === "F1" && tags === "U1") {
        obj.title = "Facility User Access";
        obj.tag = "F1";
      } else {
        obj.title = this.result.basic.title;
      }
      return obj;
    }
  }
};
</script>
